// @ts-nocheck
import * as Types from '../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import { FloorPlanOptionGroup_CheckoutOptionGroupFragmentDoc } from '../components/organisms/FloorPlan.generated';
export type ConfiguratorContext_AssetFragment = { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined, thumbnail155?: string | null | undefined };

export type ConfiguratorContext_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, displayName: string, modelNumber?: string | null | undefined, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined };

export type ConfiguratorContext_ProgramDataFragment = { __typename?: 'ProgramData', id: string, garageAttached?: number | null | undefined, garagePort?: number | null | undefined, bedrooms?: number | null | undefined, halfBaths?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined };

export type ConfiguratorContext_CheckoutConfigInteriorSubStepFragment = { __typename?: 'CheckoutConfigInteriorSubStep', id: string, displayName: string, stepNumber: number, location?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string } } | null | undefined };

export type ConfiguratorContext_OptionGroupFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, required: boolean, isMultiOptionGroup: boolean, isSingleOptionGroup: boolean, marketingDescription?: string | null | undefined, order: number, displayPackageOptionsAsSingleProduct?: boolean | null | undefined, checkoutOrder?: number | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, forDesignUpgrade: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string, description?: string | null | undefined, isElevation: boolean, isInteriorScheme: boolean, isSpecLevel: boolean, isExteriorScheme: boolean, isStructuralV2?: boolean | null | undefined } }, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined };

export type ConfiguratorContext_OptionConflictFragment = { __typename?: 'ReadyPlanOption', id: string, displayName: string, code: string };

export type ConfiguratorContext_OptionFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, description?: string | null | undefined, code: string, checkoutOrder?: number | null | undefined, optionImage?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined, thumbnail155?: string | null | undefined } | null | undefined, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, code: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }> };

export type ConfiguratorContext_CheckoutConfigPotentialOptionFragment = { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, isSelected: boolean, isEnabled: boolean, option: { __typename?: 'ReadyPlanOption', id: string, name: string, displayName: string, description?: string | null | undefined, code: string, checkoutOrder?: number | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, marketingDescription?: string | null | undefined }, optionImage?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined, thumbnail155?: string | null | undefined } | null | undefined, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, code: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }> } };

export type ConfiguratorContext_CheckoutOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, cutoffDate?: Types.Scalars['Date']['input'] | null | undefined, isEnabled: boolean, subStepNumber?: number | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, required: boolean, isMultiOptionGroup: boolean, name: string, isSingleOptionGroup: boolean, marketingDescription?: string | null | undefined, order: number, displayPackageOptionsAsSingleProduct?: boolean | null | undefined, checkoutOrder?: number | null | undefined, groupPrereqChildren: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string }, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined }>, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, marketingName: string, location: { __typename?: 'Location', id: string, name: string } } | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, forDesignUpgrade: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string, description?: string | null | undefined, isElevation: boolean, isInteriorScheme: boolean, isSpecLevel: boolean, isExteriorScheme: boolean, isStructuralV2?: boolean | null | undefined } }, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, isSelected: boolean, totalPriceInCents: number, isEnabled: boolean, option: { __typename?: 'ReadyPlanOption', id: string, code: string, name: string, displayName: string, description?: string | null | undefined, checkoutOrder?: number | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string, marketingDescription?: string | null | undefined }, optionImage?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined, thumbnail155?: string | null | undefined } | null | undefined, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }> } } }>, parentGroup?: { __typename?: 'ReadyPlanOptionGroup', id: string } | null | undefined, childGroup?: { __typename?: 'ReadyPlanOptionGroup', id: string } | null | undefined };

export type CommonFragment_FloorPlanAssetFragment = { __typename?: 'ReadyPlanAsset', id: string, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType, name: string }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } };

export type InteriorStep_LocationFragment = { __typename?: 'Location', id: string, name: string, room?: { __typename?: 'Location', id: string } | null | undefined };

export type InteriorStep_CheckoutConfigPackageOptionSlotFragment = { __typename?: 'CheckoutConfigPackageOptionSlot', id: string, location: { __typename?: 'Location', id: string, name: string }, materialVariant: { __typename?: 'MaterialVariant', id: string, displayName: string, modelNumber?: string | null | undefined, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, contentType: string, largePreview?: string | null | undefined, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined } };

export type ToggleOption_CheckoutConfigOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, cutoffDate?: Types.Scalars['Date']['input'] | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, required: boolean, isMultiOptionGroup: boolean, groupPrereqChildren: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string }, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined }> }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }> }, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }> } }>, childGroup?: { __typename?: 'ReadyPlanOptionGroup', id: string } | null | undefined };

export type ToggleOption_CheckoutConfigPotentialOptionFragment = { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }> }, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }> } };

export type ToggleOption_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType } | null | undefined, groupPrerequisites: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }> }, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string }> };

export type ContextLoadAndSave_SelectedOptionFragment = { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } };

export const ConfiguratorContext_ProgramDataFragmentDoc = gql`
    fragment ConfiguratorContext_ProgramData on ProgramData {
  id
  garageAttached
  garagePort
  bedrooms
  halfBaths
  fullBaths
  sellableSqft
}
    `;
export const ConfiguratorContext_CheckoutConfigInteriorSubStepFragmentDoc = gql`
    fragment ConfiguratorContext_CheckoutConfigInteriorSubStep on CheckoutConfigInteriorSubStep {
  id
  location {
    id
    location {
      id
    }
  }
  displayName
  stepNumber
}
    `;
export const ToggleOption_ReadyPlanOptionFragmentDoc = gql`
    fragment ToggleOption_ReadyPlanOption on ReadyPlanOption {
  id
  displayName
  optionGroup {
    id
    personalizationType {
      code
    }
    groupPrerequisites {
      id
    }
  }
  optionConflicts {
    id
    code
    displayName
  }
  optionPrerequisites {
    id
    optionGroup {
      id
    }
  }
  optionPrereqChildren {
    id
  }
}
    `;
export const ToggleOption_CheckoutConfigPotentialOptionFragmentDoc = gql`
    fragment ToggleOption_CheckoutConfigPotentialOption on CheckoutConfigPotentialOption {
  id
  option {
    ...ToggleOption_ReadyPlanOption
  }
}
    ${ToggleOption_ReadyPlanOptionFragmentDoc}`;
export const ToggleOption_CheckoutConfigOptionGroupFragmentDoc = gql`
    fragment ToggleOption_CheckoutConfigOptionGroup on CheckoutConfigOptionGroup {
  id
  group {
    id
    required
    isMultiOptionGroup
    groupPrereqChildren {
      id
      name
      group {
        id
      }
      personalizationType {
        code
      }
      options {
        id
      }
    }
    groupPrerequisites {
      id
      name
      personalizationType {
        code
      }
    }
  }
  options {
    ...ToggleOption_CheckoutConfigPotentialOption
  }
  childGroup {
    id
  }
  cutoffDate
}
    ${ToggleOption_CheckoutConfigPotentialOptionFragmentDoc}`;
export const ConfiguratorContext_OptionGroupFragmentDoc = gql`
    fragment ConfiguratorContext_OptionGroup on ReadyPlanOptionGroup {
  id
  name
  required
  isMultiOptionGroup
  isSingleOptionGroup
  marketingDescription
  order
  displayPackageOptionsAsSingleProduct
  checkoutOrder
  group {
    id
    name
    type {
      id
      name
      description
      isElevation
      isInteriorScheme
      isSpecLevel
      isExteriorScheme
      isStructuralV2
    }
    forDesignInterior
    forDesignExterior
    forDesignUpgrade
  }
  personalizationType {
    code
  }
}
    `;
export const ConfiguratorContext_AssetFragmentDoc = gql`
    fragment ConfiguratorContext_Asset on Asset {
  id
  contentType
  largePreview: previewUrl(resizing: {region: FULL, width: 2500})
  thumbnail155: previewUrl(resizing: {region: FULL, width: 155})
}
    `;
export const ConfiguratorContext_OptionConflictFragmentDoc = gql`
    fragment ConfiguratorContext_OptionConflict on ReadyPlanOption {
  id
  displayName
  code
}
    `;
export const ConfiguratorContext_OptionFragmentDoc = gql`
    fragment ConfiguratorContext_Option on ReadyPlanOption {
  id
  name
  displayName
  description
  code
  checkoutOrder
  optionImage {
    ...ConfiguratorContext_Asset
  }
  optionConflicts {
    ...ConfiguratorContext_OptionConflict
  }
  optionPrerequisites {
    id
    optionGroup {
      id
    }
  }
  optionPrereqChildren {
    id
  }
}
    ${ConfiguratorContext_AssetFragmentDoc}
${ConfiguratorContext_OptionConflictFragmentDoc}`;
export const ConfiguratorContext_CheckoutConfigPotentialOptionFragmentDoc = gql`
    fragment ConfiguratorContext_CheckoutConfigPotentialOption on CheckoutConfigPotentialOption {
  id
  totalPriceInCents
  isSelected
  isEnabled
  option {
    ...ConfiguratorContext_Option
    globalOption {
      id
      marketingDescription
    }
  }
}
    ${ConfiguratorContext_OptionFragmentDoc}`;
export const ConfiguratorContext_CheckoutOptionGroupFragmentDoc = gql`
    fragment ConfiguratorContext_CheckoutOptionGroup on CheckoutConfigOptionGroup {
  id
  step
  cutoffDate
  isEnabled
  ...ToggleOption_CheckoutConfigOptionGroup
  ...FloorPlanOptionGroup_CheckoutOptionGroup
  group {
    ...ConfiguratorContext_OptionGroup
  }
  options {
    ...ConfiguratorContext_CheckoutConfigPotentialOption
  }
  subStepNumber
  parentGroup {
    id
  }
  childGroup {
    id
  }
}
    ${ToggleOption_CheckoutConfigOptionGroupFragmentDoc}
${FloorPlanOptionGroup_CheckoutOptionGroupFragmentDoc}
${ConfiguratorContext_OptionGroupFragmentDoc}
${ConfiguratorContext_CheckoutConfigPotentialOptionFragmentDoc}`;
export const CommonFragment_FloorPlanAssetFragmentDoc = gql`
    fragment CommonFragment_FloorPlanAsset on ReadyPlanAsset {
  id
  type {
    code
    name
  }
  asset {
    id
    downloadUrl
  }
}
    `;
export const InteriorStep_LocationFragmentDoc = gql`
    fragment InteriorStep_Location on Location {
  id
  name
  room {
    id
  }
}
    `;
export const ConfiguratorContext_MaterialVariantFragmentDoc = gql`
    fragment ConfiguratorContext_MaterialVariant on MaterialVariant {
  id
  displayName
  modelNumber
  listing {
    id
    description
    brand {
      id
      name
    }
  }
  featuredImage {
    id
    asset {
      ...ConfiguratorContext_Asset
    }
  }
}
    ${ConfiguratorContext_AssetFragmentDoc}`;
export const InteriorStep_CheckoutConfigPackageOptionSlotFragmentDoc = gql`
    fragment InteriorStep_CheckoutConfigPackageOptionSlot on CheckoutConfigPackageOptionSlot {
  id
  location {
    id
    name
  }
  materialVariant {
    ...ConfiguratorContext_MaterialVariant
  }
}
    ${ConfiguratorContext_MaterialVariantFragmentDoc}`;
export const ContextLoadAndSave_SelectedOptionFragmentDoc = gql`
    fragment ContextLoadAndSave_SelectedOption on CheckoutConfigPotentialOption {
  id
  totalPriceInCents
  option {
    id
    name
    code
  }
}
    `;